define('viewmodels/site/failure',['lodash', 'atn/atn', 'knockout','dataSource/oemMessages'], 
    function(_, atn, ko, oemMessages) {
    'use strict';

    var errorMessages = ko.observableArray([]),
        FALLBACK_MSG_ID = 'unknownError';

    return {
        activate: activate,
        errorMessages: errorMessages,
        oemMessages: oemMessages.oemMessages,
        capsProductName: atn.config.messages.general.capsProductName
    };

    function activate(msgId) {
        getErrorMessages(msgId);
        return true;
    }

    function getErrorMessages(msgId) {
        var errorMsgs = atn.utils.get(
            atn.config.messages.failurePage,
            msgId || FALLBACK_MSG_ID
        );

        // in case error message is not a list of strings,
        // convert it to single-element list
        if (_.isString(errorMsgs)) {
            errorMsgs = [errorMsgs];
        }

        errorMessages(errorMsgs);
    }
});
